import { Link } from "react-router-dom";
import { withLayout } from "../../components/feature/PageLayout";
import SEOHead from "../../components/feature/SEOHead";

const siteUrl = (import.meta.env.VITE_SITE_URL || "").replace(/\/+$/, "");

const stories = [
  {
    tag: "成功故事",
    title: "家庭主婦 → 建立每月 3–5 萬彈性收入目標",
    desc: "從零開始、利用每日 1–2 小時完成學習與分享。透過「心態調頻 → 精油應用 → 分享話術 → 團隊複製」四步驟，在 90 天內完成第一筆收入，並逐步建立自己的分享節奏。",
    note: "個案經驗不代表所有人皆可達成相同成果。",
    image: "https://readdy.ai/api/search-image?query=Happy%20woman%20in%20a%20cozy%20home%20setting%2C%20smiling%20while%20organizing%20essential%20oil%20bottles%20on%20a%20wooden%20table%2C%20warm%20natural%20light%20from%20window%2C%20casual%20elegant%20outfit%2C%20cream%20and%20beige%20interior%2C%20feminine%20lifestyle%20business%20photography%2C%20confident%20and%20peaceful%20expression&width=800&height=600&seq=test-story-01&orientation=landscape",
  },
  {
    tag: "成功故事",
    title: "年輕小資族 → 斜槓轉職成功",
    desc: "白天上班、夜晚與週末經營個人品牌內容。透過短影音＋社群導流進入 LINE 私密社群，三個月內累積諮詢名單，逐步走向更適合自己的事業選擇。",
    note: "實際成果仍需視個人投入與市場狀況而定。",
    image: "https://readdy.ai/api/search-image?query=Young%20professional%20woman%20working%20on%20laptop%20at%20a%20minimal%20desk%2C%20essential%20oil%20diffuser%20nearby%2C%20warm%20evening%20lighting%2C%20modern%20apartment%20interior%2C%20confident%20side%20hustle%20vibe%2C%20cream%20and%20warm%20beige%20tones%2C%20lifestyle%20entrepreneurship%20photography&width=800&height=600&seq=test-story-02&orientation=landscape",
  },
];

const videoCards = [
  {
    title: "全職媽媽：90 天拿到第一筆收入",
    sub: "品牌故事｜芳香 × 系統",
    image: "https://readdy.ai/api/search-image?query=A%20loving%20mother%20holding%20her%20baby%20while%20gently%20using%20an%20essential%20oil%20roller%2C%20warm%20family%20home%20setting%2C%20soft%20natural%20lighting%2C%20cozy%20cream%20living%20room%2C%20peaceful%20motherhood%20and%20wellness%20aesthetic%2C%20feminine%20lifestyle%20photography&width=600&height=450&seq=test-video-01&orientation=landscape",
  },
  {
    title: "小資族：下班經營，三個月轉職",
    sub: "斜槓成功｜短影音導流",
    image: "https://readdy.ai/api/search-image?query=Young%20woman%20filming%20content%20with%20phone%20on%20tripod%2C%20essential%20oil%20bottles%20displayed%20artfully%2C%20bright%20airy%20room%20with%20plants%2C%20creative%20content%20creator%20setup%2C%20warm%20beige%20and%20cream%20tones%2C%20lifestyle%20influencer%20photography&width=600&height=450&seq=test-video-02&orientation=landscape",
  },
  {
    title: "新人：第一次分享就成交",
    sub: "複製話術｜團隊支援",
    image: "https://readdy.ai/api/search-image?query=Woman%20having%20a%20warm%20conversation%20with%20friends%20over%20tea%2C%20essential%20oil%20bottles%20on%20a%20coffee%20table%2C%20natural%20smiling%20and%20sharing%2C%20cozy%20living%20room%20with%20soft%20lighting%2C%20cream%20and%20beige%20interior%2C%20authentic%20connection%20photography&width=600&height=450&seq=test-video-03&orientation=landscape",
  },
  {
    title: "領導人：建立屬於妳的團隊文化",
    sub: "培訓養成｜領導升級",
    image: "https://readdy.ai/api/search-image?query=Confident%20woman%20leading%20a%20workshop%20with%20a%20small%20group%20of%20attentive%20women%2C%20whiteboard%20with%20notes%2C%20essential%20oil%20display%2C%20warm%20bright%20room%2C%20empowering%20leadership%20atmosphere%2C%20cream%20walls%2C%20professional%20yet%20warm%20vibe&width=600&height=450&seq=test-video-04&orientation=landscape",
  },
];

function Testimonials() {
  return (
    <>
      <SEOHead
        structuredData={{
          "@context": "https://schema.org",
          "@type": "ItemList",
          "name": "成功見證｜學員故事集",
          "description": "家庭主婦、小資族與團隊夥伴透過芳香創富系統的行動故事與成果分享。",
          "numberOfItems": 2,
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "item": {
                "@type": "Article",
                "name": "家庭主婦 → 建立每月 3–5 萬彈性收入目標",
                "description": "從零開始、利用每日 1–2 小時完成學習與分享，在 90 天內完成第一筆收入。"
              }
            },
            {
              "@type": "ListItem",
              "position": 2,
              "item": {
                "@type": "Article",
                "name": "年輕小資族 → 斜槓轉職成功",
                "description": "白天上班、夜晚與週末經營個人品牌，三個月內累積諮詢名單逐步走向新事業。"
              }
            }
          ]
        }}
      />
      {/* Hero */}
      <section className="relative w-full h-[350px] md:h-[500px] flex items-center justify-center overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Group%20of%20diverse%20women%20sitting%20together%20in%20a%20beautiful%20bright%20room%2C%20sharing%20and%20supporting%20each%20other%2C%20essential%20oil%20bottles%20and%20notebooks%20on%20tables%2C%20warm%20golden%20light%20streaming%20through%20large%20windows%2C%20community%20and%20empowerment%20vibe%2C%20cream%20and%20beige%20interior%2C%20feminine%20success%20photography&width=1800&height=800&seq=test-hero-bg&orientation=landscape"
          alt="成功見證 - 團隊成果與學員故事"
          title="香氛女王的幸福大地 成功見證"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/30"></div>
        <div className="relative z-10 w-full max-w-[1120px] mx-auto px-4 md:px-6 text-center">
          <h1 className="text-[2rem] md:text-[2.75rem] font-bold text-white leading-[1.3] mb-3 md:mb-4">
            妳也可複製成功！
          </h1>
          <p className="text-[1.1875rem] text-white/80 leading-[1.75] max-w-[680px] mx-auto mb-4">
            從家庭主婦到創造彈性收入，從年輕小資到找到新的事業方向——這些故事，都是從學習、行動與被支持開始。
          </p>
          <p className="text-[1rem] text-white/60 leading-[1.6] max-w-[680px] mx-auto">
            以下為個案經驗分享，成果依個人投入、學習狀況、行動力與市場環境而不同，不代表收入保證。
          </p>
        </div>
      </section>

      {/* Stories */}
      <section className="py-14 md:py-20 bg-background-50">
        <div className="max-w-[1120px] mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-7">
            {stories.map((story) => (
              <div
                key={story.title}
                className="bg-white rounded-[18px] overflow-hidden shadow-[0_2px_12px_rgba(0,0,0,0.06)]"
              >
                <div className="w-full h-[220px] md:h-[260px] overflow-hidden">
                  <img
                    src={story.image}
                    alt={story.title}
                    title={story.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-5 md:p-6">
                  <span className="inline-block text-[1rem] font-medium text-accent-700 bg-accent-100/70 rounded-full px-2.5 py-0.5 mb-3">
                    {story.tag}
                  </span>
                  <h3 className="text-[1.125rem] md:text-[1.25rem] font-semibold text-foreground-950 leading-[1.5] mb-2.5">
                    {story.title}
                  </h3>
                  <p className="text-[1.1875rem] text-foreground-600 leading-[1.75] mb-3">
                    {story.desc}
                  </p>
                  <p className="text-[1rem] text-foreground-600/70 leading-[1.5] italic">
                    {story.note}
                  </p>
                </div>
              </div>
            ))}
            {/* Stats Card */}
            <div className="bg-secondary-500 rounded-[18px] p-6 md:p-8 flex flex-col justify-center">
              <h3 className="text-[1.25rem] font-semibold text-white mb-5">
                成果展示數據
              </h3>
              <div className="space-y-4">
                <div>
                  <p className="text-[2rem] md:text-[2.5rem] font-bold text-primary-500 leading-[1.2]">
                    6000+
                  </p>
                  <p className="text-[1.0625rem] text-white/75">目前團隊成員</p>
                </div>
                <div>
                  <p className="text-[2rem] md:text-[2.5rem] font-bold text-primary-500 leading-[1.2]">
                    全台
                  </p>
                  <p className="text-[1.0625rem] text-white/75">
                    據點遍佈各縣市
                  </p>
                </div>
                <div>
                  <p className="text-[2rem] md:text-[2.5rem] font-bold text-primary-500 leading-[1.2]">
                    30–60 秒
                  </p>
                  <p className="text-[1.0625rem] text-white/75">
                    真實見證短影音
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Video Testimonials */}
      <section className="py-14 md:py-20 bg-background-50">
        <div className="max-w-[1120px] mx-auto px-4 md:px-6">
          <div className="mb-10 md:mb-12">
            <h2 className="text-[1.5rem] md:text-[2.125rem] font-bold text-foreground-950 leading-[1.4] mb-2">
              見證影片
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {videoCards.map((video) => (
              <div
                key={video.title}
                className="bg-white rounded-[18px] overflow-hidden shadow-[0_2px_12px_rgba(0,0,0,0.06)]"
              >
                <div className="w-full h-[180px] md:h-[200px] overflow-hidden">
                  <img
                    src={video.image}
                    alt={video.title}
                    title={video.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="text-[1.0625rem] md:text-[1.125rem] font-semibold text-foreground-950 leading-[1.5] mb-1.5">
                    {video.title}
                  </h3>
                  <p className="text-[1rem] text-foreground-600 leading-[1.6]">
                    {video.sub}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="relative py-16 md:py-24 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20inspiring%20workshop%20scene%20with%20women%20celebrating%20together%2C%20hands%20raised%20in%20joy%2C%20essential%20oil%20bottles%20and%20certificates%20on%20table%2C%20golden%20evening%20light%2C%20cream%20and%20warm%20amber%20tones%2C%20achievement%20and%20community%20celebration%2C%20cinematic%20soft%20focus&width=1800&height=700&seq=test-cta-bg&orientation=landscape"
          alt="芳香創富 CTA"
          title="芳香創富 加入LINE"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>
        <div className="relative z-10 max-w-[1120px] mx-auto px-4 md:px-6 text-center">
          <h2 className="text-[1.5rem] md:text-[2.125rem] font-bold text-white leading-[1.4] mb-3">
            想知道她們怎麼做到的？
          </h2>
          <p className="text-[1.1875rem] text-white/80 leading-[1.75] mb-6">
            加入 LINE 私密社群，取得新手 90 天啟動指南與免費說明會名額。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="https://line.me/R/ti/p/@your-id"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center justify-center px-7 py-3 rounded-full text-[1.0625rem] font-medium whitespace-nowrap cursor-pointer bg-primary-500 text-white hover:bg-primary-600 transition-colors duration-200"
            >
              加入 LINE@
            </a>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center px-7 py-3 rounded-full text-[1.0625rem] font-medium whitespace-nowrap cursor-pointer border-2 border-white text-white hover:bg-white/15 transition-colors duration-200"
            >
              預約免費諮詢
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default withLayout(Testimonials);